var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1620,
    height: 588,
    viewBox: "0 0 1620 588",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2036.72 80.9944C1942.23 37.8917 1839.92 26.016 1739.66 35.2895C1732.7 35.9519 1725.7 36.6616 1718.74 37.5605C1505.81 62.2582 1316.68 178.176 1126.69 290.593C726.284 525.931 279.077 691.055 -150.054 509.04C-187.531 492.906 -223.824 473.981 -258.319 452.406C-318.65 414.65 -373.398 368.803 -419.249 315.622C-369.612 358.914 -315.527 394.967 -258.319 424.301C-122.894 493.71 29.5666 525.6 179.472 526.546C681.994 529.338 1104.03 196.297 1389.07 79.6696C1497.81 35.4314 1597.7 6.09701 1716.05 1.64954C1723.99 1.41297 1731.85 1.36566 1739.7 1.41297C1845.75 1.69685 1945.87 22.9406 2036.77 81.0417L2036.72 80.9944Z",
    fill: "#21273D",
    stroke: "#21273D",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWave);
export default __webpack_public_path__ + "static/media/background-wave.4beb022057f287e39d1ec0c07cd2ac8e.svg";
export { ForwardRef as ReactComponent };